<div class="fs-2 with-close" mat-dialog-title>
    Compte de démonstration
    <i class="fa fa-close" (click)="onCloseClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p class="text-center mb-0">
        Non accessible en compte de démonstration.
    </p>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onCloseClick()" class="btn w-100">
        J'ai compris
    </button>
</div>
